import { render, staticRenderFns } from "./update-paper-dialog.vue?vue&type=template&id=1a1094ed&scoped=true"
import script from "./update-paper-dialog.vue?vue&type=script&lang=js"
export * from "./update-paper-dialog.vue?vue&type=script&lang=js"
import style0 from "./update-paper-dialog.vue?vue&type=style&index=0&id=1a1094ed&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1094ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1094ed')) {
      api.createRecord('1a1094ed', component.options)
    } else {
      api.reload('1a1094ed', component.options)
    }
    module.hot.accept("./update-paper-dialog.vue?vue&type=template&id=1a1094ed&scoped=true", function () {
      api.rerender('1a1094ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/update-paper-dialog.vue"
export default component.exports